export class AnotherDirector {
  firstName!: string;
  lastName!: string;
  email!: string;
  constructor() {
  }
}
